import { NotificationsService } from "@starsoft/common/services";

export class ChatbotNotificationService<T> extends NotificationsService<T> {}
